// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

interface WizardStorageBannerProps {
  visible: boolean;
}

export function WizardStorageBanner({ visible }: WizardStorageBannerProps) {
  if (!visible) return null;

  return (
    <div role="status" style={{ marginBottom: '1rem' }}>
      <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-700">
        <span className="mr-1">{'\u2139'}</span>
        Your browser&apos;s local storage is unavailable. Your progress will not be saved if you
        close this page.
      </div>
    </div>
  );
}
